import { render, staticRenderFns } from "./ArenaRoom.vue?vue&type=template&id=bcb025bc&scoped=true&"
import script from "./ArenaRoom.vue?vue&type=script&lang=js&"
export * from "./ArenaRoom.vue?vue&type=script&lang=js&"
import style0 from "./ArenaRoom.vue?vue&type=style&index=0&id=bcb025bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb025bc",
  null
  
)

export default component.exports